module.exports = __webpack_public_path__ + "prod/1.42.2/img/menu-left-bg.4486364b.png";